import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { settingsRepository } from '@webapp/platform/finance'
import { SubmitExpenseReportUseCase } from './SubmitExpenseReportUseCase'

export const submitExpenseReportUseCase = new SubmitExpenseReportUseCase({
  expenseRepository,
  settingsRepository,
})

export { SubmitExpenseReportUseCase } from './SubmitExpenseReportUseCase'
